<template>
  <div class="main-layout">
    <div class="layout-title">
      <u-title-page :title="NameComponent" />
    </div>
    <div class="layout-content">
      <u-table
        :headers="headers"
        :items="items"
        :mobileBreakpoint="900"
        :showSelect="false"
        itemKey="task_id"
        :pagination="pagination"
        @onChangePagination="onChangePagination"
        :loading="loading"
      >
        <template v-slot:header>
          <v-row justify="space-between" class="header-custom-table">
            <!-- // # Action Group -->
            <v-col cols="12" md="4">
              <v-select
                v-model="hospital"
                :items="itemhospital"
                item-text="name"
                item-value="hospital_id"
                placeholder="โรงพยาบาล"
                label="โรงพยาบาล"
                required
                outlined
                dense
                hide-details
                :loading="loading"
              ></v-select>
            </v-col>
            <!-- // # Search Group -->
            <v-col cols="12" md="8">
              <v-row justify="end" align="end">
                <v-col cols="12" sm="6" md="5">
                  <v-select
                    v-model="result"
                    :items="itemResult"
                    item-text="text"
                    item-value="val"
                    placeholder="ผลลัพธ์ "
                    label="ผลลัพธ์"
                    :rules="[Rule.noInPut]"
                    required
                    outlined
                    dense
                    hide-details
                    :loading="loading"
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="6" md="5">
                  <v-text-field
                    v-model="keyword"
                    name="name"
                    outlined
                    dense
                    append-icon="mdi-magnify"
                    placeholder="ค้นหา"
                    label="ค้นหา"
                    hide-details
                    :disabled="itemhospital.length !== 0 ? false : true"
                    :loading="loading"
                    @keyup.enter="init()"
                  ></v-text-field
                ></v-col>
                <v-col cols="12" sm="12" md="2">
                  <v-btn
                    color="primary"
                    block
                    @click="init()"
                    :loading="loading"
                    :dark="itemhospital.length !== 0 ? true : false"
                    :disabled="itemhospital.length !== 0 ? false : true"
                    >ค้นหา</v-btn
                  ></v-col
                >
              </v-row>
            </v-col>
          </v-row>
        </template>
        <template v-slot:[`item.number`]="{ item }">
          {{
            pagination.row * pagination.page -
            pagination.row +
            (items.indexOf(item) + 1)
          }}
        </template>
        <template v-slot:[`item.create_date`]="{ item }">
          {{ $moment(item.start_date).add(543, "year").format("DD-MM-YYYY") }}
        </template>

        <template v-slot:[`item.resource.da`]="{ item }">
          {{
            item.resource.da != ""
              ? $moment(item.resource.da).add(543, "year").format("DD-MM-YYYY")
              : "-"
          }}
        </template>

        <template v-slot:[`item.resource.pn`]="{ item }">
          {{ item.resource.pn != "" ? item.resource.pn : "-" }}
        </template>

        <template v-slot:[`item.resource.po`]="{ item }">
          {{ item.resource.po != "" ? item.resource.po : "-" }}
        </template>

        <template v-slot:[`item.status`]="{ item }">
          <v-chip
            outlined
            small
            :color="colorStatusChip(item.status)"
            class="my-1"
          >
            {{ textStatusChip(item.status) }}
          </v-chip>
        </template>

        <template v-slot:[`item.result`]="{ item }">
          <v-chip
            v-if="!item.status"
            outlined
            small
            :color="colorStatusChip(item.status)"
            class="my-1"
          >
            {{ textStatusChip(item.status) }}
          </v-chip>
          <div v-if="item.status">
            <div v-for="data in item.processes" :key="data.process_id">
              <v-chip
                v-if="data.results.length !== 0"
                small
                color="warning"
                class="my-1"
              >
                {{ data.name }}
              </v-chip>
            </div>
            <v-chip
              v-if="statusNormal(item.processes)"
              small
              color="success"
              class="my-1"
            >
              ไม่พบโรค
            </v-chip>
          </div>
        </template>

        <template v-slot:[`item.detail`]="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-on="on"
                v-bind="attrs"
                icon
                fab
                x-small
                dark
                color="primary"
                @click="detailAll(item)"
              >
                <v-icon>mdi-clipboard-text</v-icon>
              </v-btn>
            </template>
            <span>ดูรายละเอียดทั้งหมด</span>
          </v-tooltip>
        </template>
        <template v-slot:[`item.first_name`]="{ item }">
          {{ item.first_name }} {{ item.last_name }}
        </template>
        <template v-slot:[`item.review_consult`]="{ item }">
          <v-chip
            outlined
            small
            :color="
              returnStatusWriteReviewOwner(item.user_id, item.reviews) == false
                ? 'warning'
                : 'primary'
            "
            class="my-1"
          >
            {{
              returnStatusWriteReviewOwner(item.user_id, item.reviews) == false
                ? "ยังไม่เขียน"
                : "เขียนแล้ว"
            }}
          </v-chip>
        </template>
        <template v-slot:[`item.review`]="{ item }">
          <v-chip
            outlined
            small
            :color="
              returnStatusWriteReview(item.reviews) == false
                ? 'warning'
                : 'primary'
            "
            class="my-1"
          >
            {{
              returnStatusWriteReview(item.reviews) == false
                ? "ยังไม่เขียน"
                : "เขียนแล้ว"
            }}
          </v-chip>
        </template>
        <template v-slot:[`item.description`]="{ item }">
          <span class="fix-overflow-ellipsis">
            {{
              item.description !== "" && item.description !== null
                ? item.description
                : "-"
            }}
          </span>
        </template>
      </u-table>
    </div>
    <u-card-form
      :title="formTitle"
      :subtitle="formSubTitle"
      icon="mdi-clipboard-text"
      widthDialog="1000"
      ref="form"
      v-model="dialog"
    >
      <template v-slot:form>
        <div class="d-flex pb-3">
          <div class="title-card">
            H/N :
            {{ detailItem.resource.po != "" ? detailItem.resource.po : "-" }}
          </div>
          <v-spacer></v-spacer>
        </div>
        <div class="detal-card pb-3">
          ชื่อผู้ป่วย :
          {{ detailItem.resource.pn != "" ? detailItem.resource.pn : "-" }}
        </div>
        <div class="detal-card pb-3">
          วันที่อัปโหลด :
          {{
            $moment(detailItem.start_date).add(543, "year").format("DD-MM-YYYY")
          }}
        </div>
        <div class="detal-card pb-3">
          วันที่ X-ray :
          {{
            detailItem.resource.da != ""
              ? $moment(detailItem.resource.da)
                  .add(543, "year")
                  .format("DD-MM-YYYY")
              : "-"
          }}
        </div>
        <div class="detal-card pb-3">
          ชื่อไฟล์ : {{ detailItem.resource.filename }}
        </div>
        <div style="display: flex" class="mb-n3 mt-4">
          <div class="detal-card mr-1">โรคที่พบ :</div>
          <div>
            <v-radio-group v-model="disease" row class="layout-radio">
              <v-radio
                v-for="items in detailItem.processes"
                :key="items.process_id"
                :label="items.name"
                :value="items"
                class=""
              ></v-radio>
            </v-radio-group>
          </div>
        </div>
        <v-divider class="mb-5"></v-divider>
        <div
          style="display: flex"
          v-if="
            disease.results !== null &&
            disease.results !== undefined &&
            disease.results.length !== 0
          "
        >
          <div class="">*เลือกกล่องที่ต้องการดูผล :</div>
          <div style="display: flex; flex-wrap: wrap">
            <div
              v-for="item in disease.results"
              :key="item.result_id"
              style="width: fit-content"
              class="mx-2"
            >
              <v-checkbox
                v-model="checkBoxDisease[item.name]"
                :label="`confident : ${item.confident}%`"
                :value="item"
                class="pa-0 ma-0"
              ></v-checkbox>
            </div>
          </div>
        </div>

        <v-alert text dense :color="colorIconStatus" border="left">
          {{ disease.status }}
        </v-alert>
        <div
          v-if="
            disease.results !== null &&
            disease.results !== undefined &&
            disease.results.length !== 0
          "
        >
          <squareOnImage
            :box="checkBoxDisease[disease.name]"
            :srcImage="detailItem.resource.file"
          />
        </div>
        <div
          v-if="disease.results !== undefined && disease.results.length === 0"
        >
          <v-img :src="detailItem.resource.file"></v-img>
        </div>
        <div class="detal-card mt-5">
          <div class="primary--text mb-3">เขียนข้อเสนอแนะ</div>
          <div>
            <u>{{ userInfo.first_name }} {{ userInfo.last_name }}</u>
          </div>
          <v-textarea
            v-model="review"
            auto-grow
            outlined
            rows="5"
            row-height="15"
            class="mt-3 mb-n3"
            :disabled="disabledReview"
          ></v-textarea>
          <div class="mb-5 d-flex">
            <v-spacer></v-spacer>
            <v-btn
              :disabled="!detailItem.status"
              :dark="detailItem.status"
              color="primary"
              v-if="disabledReview"
              @click="(disabledReview = false), (reviewOld = review)"
            >
              เขียนข้อเสนอแนะ
            </v-btn>
            <v-btn
              :disabled="!detailItem.status"
              :dark="detailItem.status"
              :loading="loading"
              class="mx-1"
              color="primary"
              v-if="!disabledReview"
              @click="updateReview()"
            >
              บันทึก
            </v-btn>
            <v-btn
              :disabled="!detailItem.status"
              :dark="detailItem.status"
              :loading="loading"
              color="error"
              v-if="!disabledReview"
              @click="closeUpdateReview()"
            >
              ยกเลิก
            </v-btn>
          </div>
        </div>
        <v-divider class="mb-5"></v-divider>
        <div class="detal-card">
          <div class="my-5">ข้อเสนอแนะอื่น</div>
          <span
            v-if="
              detailItem.reviews.length == 1 &&
              detailItem.reviews[0].create_by == userInfo.user_id
            "
          >
            -
          </span>
          <div v-for="item in detailItem.reviews" :key="item.review_id">
            <div v-if="item.create_by !== userInfo.user_id">
              <u>
                <span>{{ item.first_name }} {{ item.last_name }}</span>
                <span v-if="item.first_name === '' && item.last_name === ''"
                  >Unknow</span
                >
                <span v-if="item.type === 'consult'"> : consult</span>
              </u>
              <v-textarea
                :value="
                  item.description !== ''
                    ? item.description
                    : 'ยังไม่เขียนข้อเสนอแนะ'
                "
                auto-grow
                outlined
                rows="5"
                row-height="15"
                class="mt-3"
                disabled
              ></v-textarea>
            </div>
          </div>
        </div>
      </template>
      <template v-slot:actions="{}">
        <v-row>
          <v-col
            ><v-btn :loading="loading" block color="error" @click="close"
              >ปิด</v-btn
            ></v-col
          >
        </v-row>
      </template>
    </u-card-form>
  </div>
</template>

<script>
import squareOnImage from '../../components/squareOnImage.vue'
export default {
  components: {
    squareOnImage
  },
  data () {
    return {
      userInfo: {
        user_id: '',
        last_name: '',
        first_name: ''
      },
      pagination: {
        total: 0,
        page: 1,
        row: 10
      },
      loading: false,
      dialog: false,
      NameComponent: 'งาน',
      // filter
      keyword: '',
      result: 'all',
      itemResult: [
        {
          val: 'abnormal',
          text: 'ตรวจพบ'
        },
        {
          val: 'normal',
          text: 'ปกติ'
        },
        {
          val: 'all',
          text: 'ทั้งหมด'
        }
      ],
      hospital: '',
      itemhospital: [],
      // filter
      headers: [
        {
          text: 'ลำดับ',
          align: 'center',
          sortable: false,
          value: 'number'
        },
        {
          text: 'วัน/เวลา ที่อัปโหลด',
          value: 'create_date',
          sortable: false,
          align: 'center'
        },
        {
          text: 'วัน/เวลา X-ray',
          value: 'resource.da',
          sortable: false,
          align: 'center'
        },
        {
          text: 'ชื่อผู้ป่วย',
          align: 'center',
          sortable: false,
          value: 'resource.pn'
        },
        {
          text: 'H/N',
          align: 'center',
          value: 'resource.po',
          sortable: false
        },
        {
          text: 'สถานะ',
          align: 'center',
          value: 'status',
          sortable: false
        },
        {
          text: 'ผลลัพธ์',
          value: 'result',
          sortable: false,
          align: 'center'
        },
        {
          text: 'รายละเอียด',
          value: 'detail',
          sortable: false,
          align: 'center'
        },
        {
          text: 'ข้อเสนอแนะ',
          value: 'review',
          sortable: false,
          align: 'center'
        }
      ],
      items: [],
      detailItem: {
        resource: {
          po: '',
          da: ''
        },
        processes: [],
        create_date: '',
        reviews: []
      },
      // show processes
      disease: {},
      checkBoxDisease: {},

      itemConsult: [],
      consultJob: [],
      review: '',
      review_id: '',
      disabledReview: true,
      reviewOld: '',
      ststusReview: '' // update or add
    }
  },
  computed: {
    formTitle () {
      return 'รายละเอียดทั้งหมด'
    },
    formSubTitle () {
      return ''
    },
    colorIconStatus () {
      if (this.disease.status === 'pending') return 'primary'
      else if (this.disease.status === 'success') return 'success'
      else return 'red'
    }
  },
  async created () {
    this.initUserInfo()
    await this.initItemHospital()
    // await this.init()
    this.setHeaderTable()
  },

  methods: {
    setHeaderTable () {
      for (let index = 0; index < this.userInfo.permissions.length; index++) {
        if (this.userInfo.permissions[index].priority === 0) {
          this.headers = [
            {
              text: 'ลำดับ',
              align: 'center',
              sortable: false,
              value: 'number'
            },
            {
              text: 'เจ้าของงาน',
              value: 'first_name',
              sortable: false,
              align: 'left'
            },
            {
              text: 'วัน/เวลา ที่อัปโหลด',
              value: 'create_date',
              sortable: false,
              align: 'center'
            },
            {
              text: 'วัน/เวลา X-ray',
              value: 'resource.da',
              sortable: false,
              align: 'center'
            },
            {
              text: 'ชื่อผู้ป่วย',
              align: 'center',
              sortable: false,
              value: 'resource.pn'
            },
            {
              text: 'H/N',
              align: 'center',
              value: 'resource.po',
              sortable: false
            },
            {
              text: 'สถานะ',
              align: 'center',
              value: 'status',
              sortable: false
            },
            {
              text: 'ผลลัพธ์',
              value: 'result',
              sortable: false,
              align: 'center'
            },
            {
              text: 'รายละเอียด',
              value: 'detail',
              sortable: false,
              align: 'center'
            },
            {
              text: 'ข้อเสนอแนะconsult',
              value: 'review_consult',
              sortable: false,
              align: 'center'
            },
            {
              text: 'ข้อเสนอแนะ',
              value: 'review',
              sortable: false,
              align: 'center'
            }
          ]
        }
      }
    },
    async initUserInfo () {
      this.loading = true
      const res = await this.getUserInfo()
      this.loading = false
      if (res.status) {
        this.userInfo = res.data
      } else {
        this.antmessage.error(res.message)
      }
    },
    async initItemHospital () {
      this.loading = true
      const res = await this.getItemHospitalByToken()
      this.loading = false
      if (res.status) {
        this.itemhospital = res.data
        if (this.itemhospital.length !== 0) {
          this.hospital = this.itemhospital[0].hospital_id
          this.init()
        }
      } else {
        this.antmessage.error(res.message)
      }
    },
    async init () {
      this.loading = true
      // TODO เป็น Function ที่ใช้ในการ initial ข้อมูลที่จะเอามาใส่ในตราง
      const payload = {
        page: this.pagination.page,
        row: this.pagination.row,
        hospital_id: this.hospital,
        keyword: this.keyword,
        diagnosis: this.result === 'all' ? '' : this.result
      }
      const res = await this.getTaskForTable(payload)
      this.loading = false
      if (res.status) {
        this.items = res.data.data
        this.pagination = res.data.pagination
      } else {
        this.antmessage.error(res.message)
      }
    },
    async initItemConsult () {
      this.loading = true
      const payload = {
        hospital_id: this.hospital,
        tag_name: 'consult'
      }
      const res = await this.getItemConsult(payload)
      this.loading = false
      if (res.status) {
        this.itemConsult = res.data
      } else {
        this.antmessage.error(res.message)
      }
    },
    matchConsult (users = [], consultHospital = []) {
      const itemConsultOnly = []
      const arrayConsult = []
      for (let index = 0; index < users.length; index++) {
        for (let index1 = 0; index1 < consultHospital.length; index1++) {
          if (users[index] === consultHospital[index1].user_id) {
            arrayConsult.push(users[index])
            itemConsultOnly.push(consultHospital[index1])
          }
        }
      }
      this.consultJob = itemConsultOnly
    },
    returnStatusWriteReviewOwner (idOwner, reviews) {
      let status = false
      for (let index = 0; index < reviews.length; index++) {
        if (reviews[index].create_by === idOwner) {
          if (reviews[index].description !== '') {
            status = true
          }
        }
      }
      return status
    },
    returnStatusWriteReview (reviews) {
      let status = false
      for (let index = 0; index < reviews.length; index++) {
        if (reviews[index].create_by === this.userInfo.user_id) {
          if (reviews[index].description !== '') {
            status = true
          }
        }
      }
      return status
    },
    updateReview () {
      this.$swal({
        allowEnterKey: false,
        title: 'เขียนข้อเสนอแนะ',
        text: 'คุณต้องการบันทึกข้อเสนอแนะนี้ใช่หรือไม่',
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: 'ยกเลิก',
        confirmButtonText: 'ตกลง'
      }).then(async (result) => {
        if (result.isConfirmed) {
          if (this.ststusReview === 'add') {
            this.loading = true
            const payload = {
              job_id: this.detailItem.job_id,
              description: this.review
            }
            const res = await this.createHistoryReview(payload)
            this.loading = false
            if (res.status) {
              this.$swal({
                allowEnterKey: false,
                title: 'สำเร็จ',
                text: 'บันทึกข้อเสนอแนะสำเร็จ',
                icon: 'success',
                showConfirmButton: false,
                showCancelButton: false,
                timer: 3000
              })
              this.init()
              this.disabledReview = true
              this.close()
            } else {
              this.antmessage.error(res.message)
            }
          } else if (this.ststusReview === 'edit') {
            this.loading = true
            const payload = {
              job_id: this.detailItem.job_id,
              review_id: this.review_id,
              description: this.review
            }
            const res = await this.updaeteHistoryReview(payload)
            this.loading = false
            if (res.status) {
              this.$swal({
                allowEnterKey: false,
                title: 'สำเร็จ',
                text: 'บันทึกข้อเสนอแนะสำเร็จ',
                icon: 'success',
                showConfirmButton: false,
                showCancelButton: false,
                timer: 3000
              })
              this.init()
              this.disabledReview = true
              this.close()
            } else {
              this.antmessage.error(res.message)
            }
          }
        }
      })
    },
    statusNormal (processes) {
      let status = true
      for (let index = 0; index < processes.length; index++) {
        if (processes[index].results.length !== 0) {
          status = false
        }
      }
      return status
    },
    colorStatusChip (status) {
      return status === true ? 'success' : 'primary'
    },
    textStatusChip (status) {
      return status === true ? 'สำเร็จ' : 'กำลังดำเนินการ'
    },
    onChangePagination (val) {
      this.pagination.page = val.page
      this.pagination.row = val.row
      this.init()
    },
    async detailAll (item) {
      this.disabledReview = true
      // await this.initItemConsult()
      this.detailItem = await Object.assign({}, item)

      // set box image
      this.checkBoxDisease = await Object.assign({}, {})
      const checkBox = {}
      for (let index = 0; index < this.detailItem.processes.length; index++) {
        if (this.detailItem.processes[index].results.length !== 0) {
          checkBox[this.detailItem.processes[index].name] = [
            this.detailItem.processes[index].results[0]
          ]
        } else {
          checkBox[this.detailItem.processes[index].name] = []
        }
      }

      this.checkBoxDisease = Object.assign({}, checkBox)
      this.disease = await this.detailItem.processes[0]

      // ----match user consult
      // this.matchConsult(this.detailItem.users, this.itemConsult)
      // set review edit or add
      this.setReview(this.detailItem.reviews)
      this.dialog = true
    },
    closeUpdateReview () {
      this.$swal({
        allowEnterKey: false,
        title: 'ยกเลิกการเขียนข้อเสนอแนะ',
        text: 'คุณต้องการยกเลิกการเขียนข้อเสนอแนะนี้ใช่หรือไม่',
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: 'ยกเลิก',
        confirmButtonText: 'ตกลง'
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.disabledReview = true
          this.review = this.reviewOld
        }
      })
    },
    setReview (itemReview) {
      let status = 'add'
      for (let index = 0; index < itemReview.length; index++) {
        if (itemReview[index].create_by === this.userInfo.user_id) {
          status = 'edit'
          this.review = itemReview[index].description
          this.review_id = itemReview[index].review_id
        }
      }
      this.ststusReview = status
    },
    close () {
      // this.$refs.form.reset()
      // this.$refs.form.resetValidation()
      this.review = ''
      this.dialog = false
      this.editedItem = Object.assign({}, this.defaultItem)
      this.editedIndex = -1
      this.disease = {}
      this.checkBoxDisease = {}
    }
  }
}
</script>

<style lang="scss" scoped>
.layout-radio {
  margin-top: 0px !important;
  padding-top: 0px !important;
}
.title-card {
  font-size: 20px;
  font-weight: 300;
}
.detal-card {
  font-size: 18px;
  font-weight: 300;
}

/* สำหรับจัดการหน้าเพจทั้งหมด */
.main-layout {
  height: 100%;
}

/* สำหรับ จัดการ title ของเพจ */
.layout-title {
  height: 58px;
  overflow: hidden;
  margin: 0;
  padding: 0;
}

/* สำหรับจัดการ Content ของเพจ */
.layout-content {
  height: calc(100% - 58px);
  padding: 0;
  margin: 0;
}
</style>
